<section>
  <app-breadcrumb [label]="labelBreadcrumb"></app-breadcrumb>

  <div class="dashboard__main">
    <div class="dashboard__title dashboard__title--flex">
      <div class="dashboard__titleText">
        <h1>
          Bienvenido nuevamente,
          <br>
          <span>{{ userData.user.first_name}}</span>
        </h1>
      </div>

      <div class="dashboard__titleBtn" *permission="Permission['Ventas']">
        <button *ngIf="viewButtonQr()" pButton pRipple label="Opciones para iniciar venta" icon="pi pi-th-large" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded n-background n-shadow min-pad"  (click)="generateLink(storeID)" [loading]="loading"></button>
      </div>
    </div>

    <ng-container *ngTemplateOutlet="geolocalizationMessage"></ng-container>

    <div class="dashboard__directAccess">
      <div class="directAccess__items">
        <div class="directAccess__item" *permission="Permission[NuevaSolicitud.permission]" [ngStyle]="getStyle('nueva')" [ngClass]="getClass('nueva')">
          <div class="directAccess__itemLink" (click)="newSalesFlowSelection()">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="NuevaSolicitud.img" [alt]="NuevaSolicitud.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="NuevaSolicitud.imgOverlay" [alt]="NuevaSolicitud.alt">
                </div>
                <h2 class="title">{{NuevaSolicitud.label}}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>

        <div class="directAccess__item" *permission="Permission[continueRequest.permission]" [ngStyle]="getStyle('continuar')" [ngClass]="getClass('continuar')">
          <div class="directAccess__itemLink" (click)="salesFlowSelection()">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="continueRequest.img" [alt]="continueRequest.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="continueRequest.imgOverlay" [alt]="continueRequest.alt">
                </div>
                <h2 class="title">{{continueRequest.label}}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>

        <div class="directAccess__item" *permission="Permission[searchRequest.permission]" [ngStyle]="getStyle('BuscarSolicitud')" [ngClass]="getClass('BuscarSolicitud')">
          <div class="directAccess__itemLink" (click)="gotoSalesModule('pagos/buscar')">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="searchPaymentRequest.img" [alt]="searchPaymentRequest.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="searchPaymentRequest.imgOverlay" [alt]="searchPaymentRequest.alt">
                </div>
                <h2 class="title">{{searchPaymentRequest.label}}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>

        <div class="directAccess__item" *permission="Permission[generateRequest.permission]" [ngStyle]="getStyle('GenerarSolicitud')" [ngClass]="getClass('GenerarSolicitud')">
          <div class="directAccess__itemLink" (click)="gotoSalesModule('pagos/nuevo')">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="generateRequest.img" [alt]="generateRequest.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="generateRequest.imgOverlay" [alt]="generateRequest.alt">
                </div>
                <h2 class="title">{{generateRequest.label}}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>


        <div class="directAccess__item" *permission="Permission['Ventas.VerCatalogo']" [ngStyle]="getStyle('Catalogo')" [ngClass]="getClass('Catalogo')">
          <div class="directAccess__itemLink" (click)="gotoSalesModule('productos/catalogo')">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="viewCatalog.img" [alt]="viewCatalog.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="viewCatalog.imgOverlay" [alt]="viewCatalog.alt">
                </div>
                <h2 class="title">{{ viewCatalog.label }}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>

        <div class="directAccess__item" *permission="Permission[preCreditRating.permission]" [ngStyle]="getStyle('PrecalificacionCredito')" [ngClass]="getClass('PrecalificacionCredito')">
          <div class="directAccess__itemLink" (click)="gotoSalesModule('pre-calificacion-credito')">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="preCreditRating.img" [alt]="preCreditRating.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="preCreditRating.imgOverlay" [alt]="preCreditRating.alt">
                </div>
                <h2 class="title">{{preCreditRating.label}}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>

        <div class="directAccess__item" *permission="Permission[searchPaymentRequest.permission]" [ngStyle]="getStyle('BuscarSolicitud')" [ngClass]="getClass('BuscarSolicitud')">
          <div class="directAccess__itemLink" (click)="gotoSalesModule('pagos/buscar')">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="searchPaymentRequest.img" [alt]="searchPaymentRequest.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="searchPaymentRequest.imgOverlay" [alt]="searchPaymentRequest.alt">
                </div>
                <h2 class="title">{{searchPaymentRequest.label}}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>

        <div class="directAccess__item" *permission="Permission[thirdPartyPaymentRequest.permission]" [ngStyle]="getStyle('GenerarSolicitud')" [ngClass]="getClass('GenerarSolicitud')">
          <div class="directAccess__itemLink" (click)="gotoSalesModule('pagos/nuevo')">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="thirdPartyPaymentRequest.img" [alt]="thirdPartyPaymentRequest.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="thirdPartyPaymentRequest.imgOverlay" [alt]="thirdPartyPaymentRequest.alt">
                </div>
                <h2 class="title">{{thirdPartyPaymentRequest.label}}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>

        <div class="directAccess__item" *permission="Permission[saleReports.permission]" [style]="getStyle('reporteVenta')" [ngClass]="getClass('reporteVenta')" >
          <div class="directAccess__itemLink" (click)="gotoSalesModule('reportes/ventas')">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="saleReports.img" [alt]="saleReports.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="saleReports.imgOverlay" [alt]="saleReports.alt">
                </div>
                <h2 class="title">{{ saleReports.label }}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>

        <div class="directAccess__item" *permission="Permission[storePaymentReports.permission]" [style]="getStyle('ReportePagosTienda')" [ngClass]="getClass('ReportePagosTienda')">
          <div class="directAccess__itemLink" (click)="gotoSalesModule('reportes/pagos-en-tienda')">
            <div class="directAccess__itemContent">
              <div class="directAccess__itemImg">
                <img [src]="storePaymentReports.img" [alt]="storePaymentReports.alt">
              </div>
              <div class="directAccess__itemOverlay"></div>
              <div class="directAccess__itemText">
                <div class="directAccess__itemHalfOverlay">
                  <img [src]="storePaymentReports.imgOverlay" [alt]="storePaymentReports.alt">
                </div>
                <h2 class="title">{{storePaymentReports.label}}</h2>
                <p><span>Ver más</span> <i class="pi pi-chevron-right"></i></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dashboard__reports">
      <div class="chart__reports">
        <div class="chart__item">
          <div class="chart" id="graph-home" [ngClass]="{'h-28rem': basicDataSales?.datasets[0].data.length>0}" *permission="Permission['Gestion.Comercial.Reportes.Ventas']">
            <div class="chart__header">
              <h3>Ventas <p-calendar [(ngModel)]="selectedDate" appendTo="body" view="month" dateFormat="MM yy" [disabled]="true"></p-calendar></h3>
            </div>
            <div class="chart__content" *ngIf="!loading">
              <p-chart type="bar" [data]="basicDataSales" [options]="basicOptionsSales" *ngIf="basicDataSales?.datasets[0].data.length>0;else noSales"></p-chart>
            </div>
            <div class="chart__loading" *ngIf="loading">
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
                <span>Cargando...</span>
              </div>
            </div>
            <ng-template #noSales>
              <div class="chart__empty"><p>No hay ventas para mostrar.</p></div>
            </ng-template>
          </div>
        </div>

        <div class="chart__item">
          <div class="chart" [ngClass]="{'h-28rem': basicDataSales?.datasets[0].data.length>0}" *permission="Permission['Gestion.Comercial']">
            <div class="chart__header">
              <h3>Últimas comisiones</h3>
            </div>
            <div class="chart__content" *ngIf="!loading">
              <p-table [value]="commissions" styleClass="p-datatable" id="table_commissions" class="w-full">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Marca</th>
                    <th>Comisión</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-commission>
                  <tr>
                    <td>
                      <div class="datatable__info">
                        <i class="pi pi-mobile"></i>
                        <div class="datatable__infoText">
                          <p>{{commission.brand.name}}</p>
                          <span>{{commission.date | date}}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="datatable__value">
                        <p>{{commission.amount | currency}}</p>
                        <p-tag severity="info" [value]="commission.status"></p-tag>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="2"><div class="datatable__empty"><p>No hay comisiones para mostrar.</p></div></td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <div class="chart__loading" *ngIf="loading">
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
                <span>Cargando...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #geolocalizationMessage>
  <ng-container *ngIf="updatedUser">
    <div class="dashboard__message" *permission="{ permission: Permission['Tienda.Configuracion.Geolocalizacion'], externalPermission: userData.store?.latitude == null || userData.store?.longitude == null}">
      <div class="dashboard__messageCont">
        <p-messages severity="warn">
          <ng-template pTemplate>
            <div class="text">
              <p><i class="pi pi-exclamation-triangle"></i>IMPORTANTE: hay información de su tienda que es imprescindible que pueda proporcionar. Por favor, presione el botón a continuación.</p>
              <button pButton pRipple label="Establecer información" icon="pi pi-send" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded min-pad" (click)="gotoSalesModule('/tienda/ubicacion')"></button>
            </div>
          </ng-template>
        </p-messages>
      </div>
    </div>
  </ng-container>
</ng-template>


<!-- MODAL QR CODE -->
<!-- <p-dialog [(visible)]="visibleModalQR" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Iniciar la venta</h2>
          <p>Escanea este código con la cámara o lector de QR para comenzar la venta.</p>
        </div>
        <div class="dialog__text miniPad" id="qr-code">
          <div class="qr-code">
            <div class="qr-code__img big">
               <qrcode *ngIf="fullPatchUrl" [qrdata]="fullPatchUrl" [width]="500" [errorCorrectionLevel]="'M'"></qrcode>
            </div>
          </div>
        </div>
        <div class="dialog__btn smallPad">
          <button pButton pRipple label="Imprimir QR" icon="pi pi-print" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="printQr()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog> -->


<p-dialog [(visible)]="visibleModalQR" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="onModalQRHide()" (onShow)="onModalQRShow()">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Iniciar la venta</h2>
        </div>
        <div class="dialog__text miniPad">
          <div class="initSalesOptions">
            <div class="initSalesOptions__block" *ngIf="accordionVisible">
              <p-accordion class="w-full" [activeIndex]="0" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
                <!-- QR CODE -->
                <p-accordionTab iconPos="end">
                  <ng-template pTemplate="header">
                    <div class="accordion-header">
                      <span><strong>Opción 1:</strong> Código QR</span>
                      <div class="arrow"><i class="pi pi-chevron-down"></i></div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="initSalesOptions__description pb-5">
                      <p>Escanea este código con la <strong>cámara</strong> o <strong>lector de QR</strong> para comenzar la venta.</p>
                    </div>
                    <div class="initSalesOptions__content">
                      <div class="qr-code">
                        <div class="qr-code__img big">
                          <qrcode *ngIf="tinyUrl" [qrdata]="tinyUrl" [width]="500" [errorCorrectionLevel]="'M'"></qrcode>
                        </div>
                      </div>
                      <div class="btn pt-5">
                        <button pButton pRipple label="Imprimir QR" icon="pi pi-print" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="printQr()"></button>
                      </div>
                    </div>
                  </ng-template>
                </p-accordionTab>

                <!-- SMS -->
                <p-accordionTab iconPos="end">
                  <ng-template pTemplate="header">
                    <div class="accordion-header">
                      <span><strong>Opción 2:</strong> SMS</span>
                      <div class="arrow"><i class="pi pi-chevron-down"></i></div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="initSalesOptions__description pb-30">
                      <p>Ingresa el <strong>número de teléfono</strong> del cliente para enviar el link por <strong>SMS</strong>.</p>
                    </div>
                    <div class="initSalesOptions__content">
                       <form [formGroup]="form" (ngSubmit)="sendSms()">
                        <div class="form__content noPad">
                          <div class="form__group mb-35" [ngClass]="{'form__error': f['phone'].touched && f['phone'].errors}">
                            <div class="p-float-label">
                              <p-inputMask placeholder="Teléfono" id="phone" formControlName="phone" [mask]="country.phoneCountryMask"></p-inputMask>
                              <label for="phone">Número de teléfono *</label>
                              <i class="pi pi-phone"></i>
                            </div>
                            <span class="form__msgError" *ngIf=" f['phone'].touched && f['phone'].errors">
                             <small class="p-error" >{{ "El Teléfono" | required }}</small>
                            </span>
                          </div>
                          <div class="form__btn">
                            <button pButton pRipple type="submit" label="Enviar SMS" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" [loading]="isLoading"></button>
                          </div>

                          <div class="form__msg">
                            <div class="text success" *ngIf="status === STATUS_OK">
                              <i>
                                <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M61.6795 9.4412L32.1677 38.9788L21.5219 28.3237C21.5219 28.3237 19.2311 26.5703 17.0749 28.7283C14.9188 30.8863 16.6707 33.1792 16.6707 33.1792L32.1677 48.6898L66.5307 14.2967C66.5307 14.2967 68.1478 12.0038 65.9917 9.9807C63.7008 7.95758 61.6795 9.4412 61.6795 9.4412Z" fill="#0046AD"/>
                                  <path d="M69.4955 32.2351C68.8217 31.5607 67.7437 31.1561 66.5308 31.1561C63.2967 31.1561 62.3534 33.5838 62.3534 34.9326C62.3534 42.0809 59.5235 48.8247 54.5375 53.815C49.5515 58.8054 42.6789 61.6378 35.6715 61.6378C28.5294 61.6378 21.7916 58.8054 16.8056 53.815C11.8196 48.8247 8.98968 41.946 8.98968 34.9326C8.98968 27.7842 11.8196 21.0405 16.8056 16.0501C21.7916 11.0597 28.6642 8.22736 35.6715 8.22736C38.0971 8.22736 40.6575 8.63199 43.0832 9.30636C45.6435 9.98073 47.5301 10.3854 49.1472 9.17148C50.2253 8.36223 50.8991 6.60886 50.7643 5.12524C50.6295 4.04624 50.0905 3.10212 49.1472 2.6975C47.3954 1.48362 40.2533 0 35.8063 0C31.0898 0 26.6428 0.944123 22.4654 2.6975C18.2879 4.45087 14.38 7.01349 11.1458 10.2505C4.13844 16.7245 0.5 25.6262 0.5 34.9326C0.5 44.3738 4.13843 53.1407 10.7415 59.7495C13.9757 62.9865 17.8836 65.5491 22.0611 67.3025C26.2386 69.0559 30.8203 70 35.402 70C44.835 70 53.5942 66.3584 60.1973 59.7495C66.8004 53.1407 70.4388 44.3738 70.4388 34.9326C70.5735 34.9326 70.5735 33.3141 69.4955 32.2351Z" fill="#0046AD"/>
                                </svg>
                              </i>
                              <span>Se ha enviado el link por SMS correctamente.</span>
                            </div>
                            <div class="text error" *ngIf="status === STATUS_NOT_ACCEPTABLE">
                              <i>
                                <svg width="71" height="70" viewBox="0 0 71 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M30.25 50.75C30.25 49.3576 30.8031 48.0223 31.7877 47.0377C32.7723 46.0531 34.1076 45.5 35.5 45.5C36.8924 45.5 38.2277 46.0531 39.2123 47.0377C40.1969 48.0223 40.75 49.3576 40.75 50.75C40.75 52.1424 40.1969 53.4777 39.2123 54.4623C38.2277 55.4469 36.8924 56 35.5 56C34.1076 56 32.7723 55.4469 31.7877 54.4623C30.8031 53.4777 30.25 52.1424 30.25 50.75ZM32.056 16.87C32.2021 16.063 32.627 15.333 33.2564 14.8073C33.8858 14.2816 34.6799 13.9936 35.5 13.9936C36.3201 13.9936 37.1142 14.2816 37.7436 14.8073C38.373 15.333 38.7979 16.063 38.944 16.87L39 17.5V35L38.944 35.63C38.7979 36.437 38.373 37.167 37.7436 37.6927C37.1142 38.2184 36.3201 38.5064 35.5 38.5064C34.6799 38.5064 33.8858 38.2184 33.2564 37.6927C32.627 37.167 32.2021 36.437 32.056 35.63L32 35V17.5L32.056 16.87ZM70.5 35C70.5 44.2826 66.8125 53.185 60.2487 59.7487C53.685 66.3125 44.7826 70 35.5 70C26.2174 70 17.315 66.3125 10.7513 59.7487C4.18749 53.185 0.5 44.2826 0.5 35C0.5 25.7174 4.18749 16.815 10.7513 10.2513C17.315 3.68749 26.2174 0 35.5 0C44.7826 0 53.685 3.68749 60.2487 10.2513C66.8125 16.815 70.5 25.7174 70.5 35ZM63.5 35C63.5 27.5739 60.55 20.452 55.299 15.201C50.048 9.94999 42.9261 7 35.5 7C28.0739 7 20.952 9.94999 15.701 15.201C10.45 20.452 7.5 27.5739 7.5 35C7.5 42.4261 10.45 49.548 15.701 54.799C20.952 60.05 28.0739 63 35.5 63C42.9261 63 50.048 60.05 55.299 54.799C60.55 49.548 63.5 42.4261 63.5 35Z" fill="#E70F47"/>
                                </svg>
                              </i>
                              <span>Hubo un problema y no se ha podido enviar el link. Por favor inténtalo de nuevo.</span>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </ng-template>
                </p-accordionTab>

                <!-- URL -->
                <p-accordionTab iconPos="end">
                  <ng-template pTemplate="header">
                    <div class="accordion-header">
                      <span><strong>Opción 3:</strong> URL</span>
                      <div class="arrow"><i class="pi pi-chevron-down"></i></div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="initSalesOptions__description">
                      <p class="pb-15">Pídele al cliente que ingrese a esta <strong>dirección</strong> desde su celular:</p>
                      <i class="pi pi-spin pi-spinner" style="font-size: 1rem" *ngIf="isLoading"></i>
                      <p *ngIf="tinyUrl"><span class="highlight">{{ tinyUrl }}</span></p>
                    </div>
                  </ng-template>
                </p-accordionTab>

                <!-- SHARE -->
                <p-accordionTab iconPos="end">
                  <ng-template pTemplate="header">
                    <div class="accordion-header">
                      <span><strong>Opción 4:</strong> Compartir</span>
                      <div class="arrow"><i class="pi pi-chevron-down"></i></div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="initSalesOptions__description pb-30">
                      <p>Presiona el botón <strong>"Compartir"</strong> y se copiará el link en el portapapeles. Después pégalo dónde desees (ejemplo Whatsapp) para <strong>enviárselo al cliente</strong>.</p>
                    </div>
                    <div class="initSalesOptions__content">
                      <div class="btn">
                        <button pButton pRipple  [label]="copied ? 'Copiando...' : 'Compartir'" icon="pi pi-share-alt" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="copyToClipboard()" [disabled]="!tinyUrl"
                                [loading]="loading || isLoading"></button>
                      </div>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<!-- MODAL FLOW SELECTOR NUEVA SOLICITUD -->
<p-dialog [(visible)]="visibleModalFlowSelectorNewRequest" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" (onHide)="onModalFlowHide()" (onShow)="onModalFlowShow()">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2 class="smallW">Indica cómo deseas realizar la venta</h2>
          <p>{{ txtFlowSalesSelector }}</p>
        </div>
        <div class="dialog__text smallPad">
          <div class="initSalesOptions">
            <div class="initSalesOptions__block" *ngIf="accordionFlowVisible">
              <p-accordion class="w-full" expandIcon="pi pi-chevron-down" collapseIcon="pi pi-chevron-up">
                <!-- VENTA EN TIENDA -->
                <p-accordionTab iconPos="end" *ngIf="showSalesTypeOption(TypeSales.tienda)">
                  <ng-template pTemplate="header">
                    <div class="accordion-header">
                      <i class="component-icon"><app-circle-store-icon></app-circle-store-icon></i>
                      <span><strong>Venta en Tienda</strong></span>
                      <div class="arrow"><i class="pi pi-chevron-down"></i></div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="flowSelector">
                      <div class="flowSelector__description">
                        <p>{{ txtFlowSalesSelector }}</p>
                      </div>

                      <div class="flowSelector__items">
                        <div class="flowSelector__item" *ngIf="showFlowSelectorItem(TypeSalesFlow.actual)">
                          <button type="button" class="flowSelector__content" (click)="gotoSalesModule('nueva', TypeSales.tienda)">
                            <div class="info">
                              <div class="icon">
                                <i class="pi pi-table"></i>
                              </div>
                              <div class="text">
                                <h3>Forma Actual</h3>
                                <p>Usar la estructura tradicional de venta.</p>
                              </div>
                            </div>
                            <div class="btn">
                              <p><span>Continuar</span> <i class="pi pi-chevron-right"></i></p>
                            </div>
                          </button>
                        </div>

                        <div class="flowSelector__item" *ngIf="showFlowSelectorItem(TypeSalesFlow.nuevo)">
                          <button type="button" class="flowSelector__content" (click)="generateDirectLinkNew(storeID)">
                            <div class="info">
                              <div class="icon">
                                <i class="pi pi-th-large"></i>
                              </div>
                              <div class="text">
                                <h3>Forma Nueva</h3>
                                <p>Usar el nuevo diseño con funcionalidades mejoradas.</p>
                              </div>
                            </div>
                            <div class="btn">
                              <p><span>Continuar</span> <i class="pi pi-chevron-right"></i></p>
                            </div>
                          </button>
                        </div>

                        <div class="flowSelector__item" *ngIf="showFlowSelectorItem(TypeSalesFlow.experanza)">
                          <button type="button" class="flowSelector__content" (click)="generateDirectLinkExperanza(storeID)">
                            <div class="info">
                              <div class="icon">
                                <i class="pi pi-star"></i>
                              </div>
                              <div class="text">
                                <h3>Experanza</h3>
                                <p>Usar el flujo de venta Experanza.</p>
                              </div>
                            </div>
                            <div class="btn">
                              <p><span>Continuar</span> <i class="pi pi-chevron-right"></i></p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-accordionTab>

                <!-- VENTA A DOMICILIO -->
                <p-accordionTab iconPos="end" *ngIf="showSalesTypeOption(TypeSales.domicilio)">
                  <ng-template pTemplate="header">
                    <div class="accordion-header">
                      <i class="component-icon"><app-circle-home-icon></app-circle-home-icon></i>
                      <span><strong>Venta a Domicilio</strong></span>
                      <div class="arrow"><i class="pi pi-chevron-down"></i></div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="flowSelector">
                      <div class="flowSelector__description">
                        <p>{{ txtFlowSalesSelector }}</p>
                      </div>

                      <div class="flowSelector__items">
                        <div class="flowSelector__item" *ngIf="showFlowSelectorItem(TypeSalesFlow.actual)">
                          <button type="button" class="flowSelector__content" (click)="gotoSalesModule('nueva', TypeSales.domicilio)">
                            <div class="info">
                              <div class="icon">
                                <i class="pi pi-table"></i>
                              </div>
                              <div class="text">
                                <h3>Forma Actual</h3>
                                <p>Usar la estructura tradicional de venta.</p>
                              </div>
                            </div>
                            <div class="btn">
                              <p><span>Continuar</span> <i class="pi pi-chevron-right"></i></p>
                            </div>
                          </button>
                        </div>

                        <div class="flowSelector__item" *ngIf="showFlowSelectorItem(TypeSalesFlow.nuevo)">
                          <button type="button" class="flowSelector__content" (click)="generateLink(storeID, true)">
                            <div class="info">
                              <div class="icon">
                                <i *ngIf="!loadingGenerateLinkShort" class="pi pi-th-large"></i>
                                <i *ngIf="loadingGenerateLinkShort" class="pi pi-spin pi-spinner"></i>
                              </div>
                              <div class="text">
                                <h3>Forma Nueva</h3>
                                <p>Usar el nuevo diseño con funcionalidades mejoradas.</p>
                              </div>
                            </div>
                            <div class="btn">
                              <p><span>Continuar</span> <i class="pi pi-chevron-right"></i></p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-accordionTab>

                <!-- VENTA ONLINE -->
                <p-accordionTab iconPos="end" *ngIf="showFlowSelectorItem(TypeSalesFlow.online)">
                  <ng-template pTemplate="header">
                    <div class="accordion-header">
                      <i class="component-icon"><app-circle-online-icon></app-circle-online-icon></i>
                      <span><strong>Venta Online</strong></span>
                      <div class="arrow"><i class="pi pi-chevron-down"></i></div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="content">
                    <div class="flowSelector">
                      <div class="flowSelector__description">
                        <p>Envía el link a los clientes para iniciar la venta:</p>
                      </div>

                      <div class="flowSelector__items" *ngIf="showFlowSelectorItem(TypeSalesFlow.online)">
                        <div class="flowSelector__item">
                          <button type="button" class="flowSelector__content" (click)="generateLink(storeID)">
                            <div class="info">
                              <div class="icon">
                                <i *ngIf="!loadingGenerateLinkShort" class="pi pi-list"></i>
                                <i *ngIf="loadingGenerateLinkShort" class="pi pi-spin pi-spinner"></i>
                              </div>
                              <div class="text">
                                <h3>Link de Venta</h3>
                                <p>Ver las opciones para el envío del link.</p>
                              </div>
                            </div>
                            <div class="btn">
                              <p><span>Continuar</span> <i class="pi pi-chevron-right"></i></p>
                            </div>
                          </button>
                        </div>

                        <div class="flowSelector__item" *ngIf="showFlowSelectorItem(TypeSalesFlow.experanza)">
                          <button type="button" class="flowSelector__content" (click)="generateLinkExperanza(storeID)">
                            <div class="info">
                              <div class="icon">
                                <i *ngIf="!loadingGenerateLinkShort" class="pi pi-star"></i>
                                <i *ngIf="loadingGenerateLinkShort" class="pi pi-spin pi-spinner"></i>
                              </div>
                              <div class="text">
                                <h3>Experanza</h3>
                                <p>Enviar link del flujo de venta Experanza.</p>
                              </div>
                            </div>
                            <div class="btn">
                              <p><span>Continuar</span> <i class="pi pi-chevron-right"></i></p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>




<!--//************************** CAMBIO DE TIENDAS WOM *****************************//-->


<!-- MODAL TIENDA SELECCIONADA -->
<p-dialog [(visible)]="visibleModalSelectedStore" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" [closable]="false">
  <div class="dialog">
    <div class="dialog__headerImg">
      <div class="dialog__headerImgOverlay"></div>
      <div class="dialog__headerImgBack" style="background-image: url('/assets/images/backgrounds/background-store.jpg')"></div>
    </div>

    <div class="dialog__contentBlock">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__icon">
            <div class="dialog__icon dialog__icon--background">
            <span><app-circle-store-icon></app-circle-store-icon></span>
          </div>
          </div>
          <div class="dialog__info dialog__info--big">
            <small>Te encuentras en la tienda:</small>
            <h2 class="uppercase">{{ userData.store?.name }}</h2>
          </div>
          <div class="dialog__text pt-20">
            <div class="storeSelector">
              <div class="storeSelector__block">
                <div class="text pb-20">
                  <p>Al confirmar esta acción, todas las ventas que realices a partir de este momento quedaran registradas en esta tienda.</p>
                </div>

                <div class="btn">
                  <button pButton pRipple label="Confirmar" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onConfirmCurrentStore()"></button>
                </div>
              </div>

              <div class="storeSelector__block pt-20">
                <div class="separator pb-20"><span>O</span></div>

                <div class="text pb-10">
                  <p>Si no te encuentras en esta tienda, puedes seleccionar una diferente:</p>
                </div>

                <div class="btn">
                  <p-button label="Seleccionar otra tienda" icon="pi pi-angle-right" iconPos="right" [text]="true" [plain]="true" (click)="onSelectOtherStore()"></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- MODAL SELECTOR DE TIENDA -->
<p-dialog [(visible)]="visibleModalStoreList" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" [closable]="false">
  <div class="dialog">
    <div class="dialog__headerImg">
      <div class="dialog__headerImgOverlay"></div>
      <div class="dialog__headerImgBack" style="background-image: url('/assets/images/backgrounds/background-store.jpg')"></div>
    </div>

    <div class="dialog__contentBlock">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__icon">
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                <ellipse cx="34.8169" cy="35.1529" rx="33.8169" ry="33.817" fill="white"/>
                <path d="M34.9996 0C15.7012 0 0 15.7016 0 35.0013C0.0150329 37.0095 0.198893 39.0129 0.549638 40.9903C0.549638 41.0022 0.570843 40.9971 0.575084 41.0073C0.640345 41.2505 0.783505 41.4656 0.98265 41.6197C1.1818 41.7738 1.42595 41.8584 1.67775 41.8606C1.98715 41.8603 2.2838 41.7373 2.50249 41.5184C2.72119 41.2996 2.84404 41.0028 2.84404 40.6935C2.83853 40.6557 2.83088 40.6184 2.82114 40.5815L2.84149 40.5722C2.51332 38.7337 2.34306 36.8705 2.33257 35.003C2.33257 16.962 16.9582 2.33675 34.9987 2.33675C53.0392 2.33675 67.6666 16.9637 67.6666 35.003C67.6666 53.0422 53.0409 67.6683 34.9996 67.6683C22.9432 67.6683 12.4373 61.1186 6.78057 51.401C6.78057 51.395 6.77293 51.3916 6.77124 51.3857C6.75597 51.3603 6.73901 51.3357 6.72459 51.3102C6.62806 51.1231 6.48221 50.966 6.3028 50.8558C6.12339 50.7456 5.91727 50.6866 5.70674 50.6851C5.39749 50.6853 5.10097 50.8083 4.8823 51.0269C4.66363 51.2456 4.54068 51.5421 4.54045 51.8514C4.54584 52.0917 4.6272 52.3242 4.77286 52.5155L4.75335 52.5274C10.8206 62.9601 22.0916 70 35.0013 70C54.2988 70 70 54.3009 70 35.0013C70 15.7016 54.2988 0 34.9996 0Z" fill="#0046AD"/>
                <path d="M51.3978 35.2551C49.1732 35.2551 47.1638 34.2314 45.9438 32.4766C44.6521 34.2314 42.7145 35.2551 40.4899 35.2551C38.2652 35.2551 36.1841 34.2314 34.9641 32.4766C33.6724 34.2314 31.663 35.2551 29.4384 35.2551C27.2137 35.2551 25.2761 34.2314 23.9844 32.4766C22.6927 34.2314 20.7551 35.2551 18.5304 35.2551C15.8034 35.2551 13.2917 33.6465 12.2153 31.3068L12.0718 31.0874C11.8565 30.6487 11.4977 29.9176 16.1622 20.0468C16.3058 19.6812 17.0952 17.9996 18.4587 17.9996H50.6084C51.9719 17.9996 52.8331 19.6081 52.9766 19.9737C58.3588 29.9176 58.0718 30.5756 57.8565 31.0143L57.6412 31.453C56.5647 33.7927 54.1248 35.2551 51.3978 35.2551ZM46.0156 28.3821L46.805 30.3563C47.5944 32.2573 49.3885 33.4272 51.3978 33.4272C53.4789 33.4272 55.3448 32.2573 56.1342 30.4294C55.7754 29.2595 53.5507 24.7263 51.3978 20.778C51.1825 20.3393 50.752 19.8275 50.6084 19.8275H18.4587C18.3151 19.9006 17.9563 20.3393 17.741 20.778C15.947 24.7263 14.0094 29.2595 13.7941 30.3563C14.5835 32.1842 16.4493 33.4272 18.5304 33.4272C20.5398 33.4272 22.3339 32.2573 23.195 30.2831L23.9844 28.4552L24.7738 30.2831C25.6349 32.1842 27.429 33.4272 29.4384 33.4272C31.4477 33.4272 33.3136 32.1842 34.1747 30.2831L35.0359 28.3821L35.8253 30.3563C36.6147 32.2573 38.4087 33.4272 40.4899 33.4272C42.4992 33.4272 44.2933 32.2573 45.1544 30.2831L46.0156 28.3821Z" fill="#0046AD"/>
                <path d="M51.3261 51.9987H18.3869C17.0952 51.9987 16.0187 50.902 16.0187 49.5859V34.3777H17.8128V49.659C17.8128 49.9515 18.0281 50.2439 18.3869 50.2439H51.3261C51.6131 50.2439 51.9002 50.0246 51.9002 49.659V34.3777H53.6942V49.659C53.6942 50.902 52.6178 51.9987 51.3261 51.9987Z" fill="#0046AD"/>
                <path d="M38.624 47.5386H18.961V36.2787H38.624V47.5386ZM20.7551 45.7107H36.83V38.1066H20.7551V45.7107Z" fill="#0046AD"/>
                <path d="M50.8237 51.9256H39.7722V35.5475H50.8237V51.9256ZM41.5663 50.0977H49.0296V37.3754H41.5663V50.0977Z" fill="#0046AD"/>
                <path d="M25.4714 18.6925L23.0251 30.4962L24.7804 30.8738L27.2268 19.0702L25.4714 18.6925Z" fill="#0046AD"/>
                <path d="M35.7535 18.9501H33.9594V30.7218H35.7535V18.9501Z" fill="#0046AD"/>
                <path d="M43.4646 18.8609L41.7428 19.3747L45.0511 30.8826L46.7729 30.3688L43.4646 18.8609Z" fill="#0046AD"/>
                <path d="M26.5679 37.2292H24.7738V46.6612H26.5679V37.2292Z" fill="#0046AD"/>
                <path d="M32.9548 37.2292H31.1607V46.6612H32.9548V37.2292Z" fill="#0046AD"/>
              </svg>
            </span>
          </div>
          <div class="dialog__info dialog__info--big">
            <h2>Selección de tienda</h2>
          </div>
          <div class="dialog__text pt-20">
            <div class="storeSelector">
              <div class="storeSelector__block pb-15">
                <div class="text">
                  <p>Selecciona la tienda en la que vas a registrar tu ventas:</p>
                </div>
              </div>
              <div class="storeSelector__block">
                <div class="storeSelector__table">
                  <p-table #dt [value]="stores" [rows]="4" [paginator]="true" [globalFilterFields]="['name']" [tableStyle]="{ 'min-width': '100%' }">

                    <!-- CAPTION -->
                    <ng-template pTemplate="caption">
                      <div class="searchBox">
                        <div class="searchBox__input">
                          <i class="pi pi-search"></i>
                          <input
                            #storeFilter
                            type="text"
                            pInputText
                            placeholder="Buscar tienda..."
                            (input)="dt.filterGlobal(storeFilter.value, 'contains')"
                          />
                        </div>
                      </div>

                    <div class="amountProductRef pt-15 pb-5">
                      <ng-container *ngIf="(dt.filteredValue?.length ?? stores.length) !== 1">
                        <p>Se han listado:</p> <span><strong>{{ dt.filteredValue?.length ?? stores.length }}</strong> tiendas</span>
                      </ng-container>

                      <ng-container *ngIf="(dt.filteredValue?.length ?? stores.length) === 1">
                        <p>Se ha listado:</p> <span><strong>1</strong> tienda</span>
                      </ng-container>
                    </div>
                  </ng-template>

                    <!-- CONTENT -->
                    <ng-template pTemplate="body" let-store>
                      <tr>
                        <td>
                          <div class="storeSelector__item">
                          <p-selectButton [options]="[{ label: store.name, value: store.id }]" [(ngModel)]="selectedStore" optionLabel="label" optionValue="value">
                            <ng-template pTemplate="item">
                              <div class="storeSelector__itemInfo">
                                <div class="infoData">
                                  <i><app-location-icon></app-location-icon></i>
                                  <h3>{{ store.name }}</h3>
                                </div>
                                <div class="infoMarker"></div>
                              </div>
                            </ng-template>
                          </p-selectButton>
                          </div>
                        </td>
                      </tr>
                    </ng-template>

                    <!-- EMPTY MESSAGE -->
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="1">
                          <div class="storeSelector__empty">
                            <p>No se ha encontrado ninguna tienda.</p>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>

              <div class="storeSelector__block pt-30">
                <div class="btn btn--flex">
                  <button pButton pRipple label="Cancelar" class="p-button-secondary p-button-raised p-button-rounded w-full" (click)="onCancelStoreSelection()"></button>
                  <button pButton pRipple label="Seleccionar" class="p-button-primary p-button-raised p-button-rounded w-full" [disabled]="!selectedStore" (click)="onConfirmStoreSelection()" [loading]="loadingChangeStore"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>


<!-- MODAL CONFIRMACIÓN TIENDA SELECCIONADA -->
<p-dialog [(visible)]="visibleModalConfirmStore" [modal]="true" [draggable]="false" [resizable]="false" position="bottom" [closable]="false">
  <div class="dialog">
    <div class="dialog__headerImg">
      <div class="dialog__headerImgOverlay"></div>
      <div class="dialog__headerImgBack" style="background-image: url('/assets/images/backgrounds/background-store.jpg')"></div>
    </div>

    <div class="dialog__contentBlock">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__icon dialog__icon--background">
            <span><app-circle-store-icon></app-circle-store-icon></span>
          </div>
          <div class="dialog__info dialog__info--big">
            <h2>Confirmación</h2>
          </div>
          <div class="dialog__text pt-20">
            <div class="storeSelector">
              <div class="storeSelector__block">
                <div class="storeSelector__selection pb-20">
                  <div class="storeSelector__selectionIcon">
                    <i><app-location-icon></app-location-icon></i>
                  </div>
                  <div class="storeSelector__selectionText">
                    <span>Tienda seleccionada:</span>
                    <p>{{ selectedStoreName }}</p>
                  </div>
                </div>
              </div>

              <div class="storeSelector__block pt-25">
                <div class="text pb-30">
                  <p class="pb-20">¿Estás seguro que deseas confirmar esta acción?</p>
                  <p>Recuerda que todas las ventas que realices a partir de este momento quedaran registradas en la tienda seleccionada.</p>
                </div>

                <div class="btn btn--flex">
                  <button pButton pRipple label="Cancelar" class="p-button-secondary p-button-raised p-button-rounded w-full" (click)="onCancelConfirmStore()"></button>
                  <button pButton pRipple label="Confirmar" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onConfirmStoreChange()" [loading]="loadingChangeStore"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
